export default __webpack_public_path__ + "static/media/bookcritiq.353a6876.png";